<template>
    <el-container class="file-manager">
        <!-- 内容区域 -->
        <el-main>
            <div class="file-toolbar">
                <!-- 左侧：当前文件夹信息 -->
                <div class="file-toolbar__info">
                    <span class="file-toolbar__icon">
                        <el-icon>
                            <FolderOpened />
                        </el-icon>
                    </span>
                    <span class="file-toolbar__meta">
                        <span class="file-toolbar__title">{{ currentBucket.name || '未选择文件夹' }}</span>
                        <span class="file-toolbar__subtitle">{{ currentBucket.id ? '共 ' + dataTotal + ' 个文件' : '请选择文件夹' }}</span>
                    </span>
                </div>
                <!-- 小屏：文件夹选择（替代左侧列表） -->
                <el-select class="file-toolbar__folder" :model-value="currentBucket.id" placeholder="选择文件夹"
                    @change="selectBucketById">
                    <el-option-group label="系统预置">
                        <el-option v-for="item in filterBucketList('sys')" :key="item.id" :label="item.name"
                            :value="item.id" />
                    </el-option-group>
                    <el-option-group label="用户自定义">
                        <el-option v-for="item in filterBucketList('user')" :key="item.id" :label="item.name"
                            :value="item.id" />
                    </el-option-group>
                </el-select>
                <!-- 右侧：操作按钮 -->
                <div class="file-toolbar__actions">
                    <el-button class="toolbar-btn toolbar-btn--ghost" @click="openCreateBucket">
                        <el-icon>
                            <FolderAdd />
                        </el-icon><span>创建目录</span>
                    </el-button>
                    <el-button v-if="createDocVisible && !isSysBucket" class="toolbar-btn toolbar-btn--ghost"
                        @click="openEditBucket">
                        <el-icon>
                            <EditPen />
                        </el-icon><span>编辑目录</span>
                    </el-button>
                    <el-button v-if="createDocVisible && !isSysBucket" class="toolbar-btn toolbar-btn--ghost toolbar-btn--danger"
                        @click="deleteBucket">
                        <el-icon>
                            <Delete />
                        </el-icon><span>删除目录</span>
                    </el-button>
                    <span v-if="createDocVisible" class="file-toolbar__split"></span>
                    <el-button v-if="createDocVisible" class="toolbar-btn toolbar-btn--primary" @click="openUploadDialog">
                        <el-icon>
                            <UploadFilled />
                        </el-icon><span>上传文件</span>
                    </el-button>
                </div>
            </div>
            <div class="file-manager__body">
                <div class="file-manager__aside">
                    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                        <el-menu-item-group title="系统预置">
                            <el-menu-item v-for="item in filterBucketList('sys')" :key="item.id.toString()"
                                :index="item.id" @click="selectBucket(item)">{{ item.name }}</el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group title="用户自定义">
                            <el-menu-item v-for="item in filterBucketList('user')" :key="item.id.toString()"
                                :index="item.id" @click="selectBucket(item)">{{ item.name }}</el-menu-item>
                        </el-menu-item-group>
                    </el-menu>
                </div>
                <div class="file-manager__content">
                    <div class="file-manager__grid">
                        <el-empty v-if="tableData.length === 0" :description="emptyText" />
                        <el-row v-else>
                            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-for="item in tableData" :key="item.id">
                                <file-manager-card :item="item" :show-share="canShare" :show-delete="canDelete"
                                    @history="fileHistory" @download="fileDownload" @copy-url="copyDownloadUrl"
                                    @share="fileShare" @delete="fileDelete" />
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="dataTotal > pageSize" class="file-pager">
                        <el-pagination background small :pager-count="5" layout="prev, pager, next"
                            :current-page="currentPage" :page-size="pageSize" :total="dataTotal"
                            @current-change="handlePageChange" />
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
    <el-backtop target=".file-manager__grid"></el-backtop>

    <!-- Form -->
    <el-dialog :title="this.dialogFormMode == 'create' ? '创建文件夹' : '编辑文件夹'" v-model="dialogFormVisible">
        <el-form :model="collectedForm">
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="collectedForm.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="公开" :label-width="formLabelWidth">
                <el-switch v-model="collectedForm.isOpen" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBucket">保 存</el-button>
            </span>
        </template>
    </el-dialog>

    <el-dialog :title="上传文件" v-model="dialogUploadVisible">
        <file-upload v-bind:bucket="currentBucket" :callback="uploadCallback" ref="fileUpload"></file-upload>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" @click="dialogUploadVisible = false">完 成</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
import { config } from '@/utils/config';
import FileUpload from './FileUpload';
import FileManagerCard from './FileManagerCard';
import { copy } from '../../../utils/clipboard.js';
import _ from 'lodash';
export default {
    data() {
        return {
            currentBucket: {},
            bucketList: [],
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            dataTotal: 0,
            dialogFormMode: 'create',
            dialogFormVisible: false,
            dialogUploadVisible: false,
            createDocVisible: false,
            collectedForm: {
                name: '',
                description: '',
                isOpen: false
            },
            formLabelWidth: '120px'
        };
    },
    mounted() {
        //  debugger;
        let token = this.$store.state.user.token;
        console.log('token-1-1-1: ' + token);

        let name = this.$store.state.user.name;
        console.log('name: ' + name);

        this.loadBucket();
    },
    components: { FileUpload, FileManagerCard },
    computed: {
        // 用户自定义文件夹才允许分享
        canShare() {
            return (this.currentBucket.name || '').indexOf('.') < 0;
        },
        // 系统预置文件夹（名称含 . ）不允许编辑和删除
        isSysBucket() {
            return (this.currentBucket.name || '').indexOf('.') >= 0;
        },
        // 用户自定义文件夹或分享文件夹允许删除
        canDelete() {
            let name = this.currentBucket.name || '';
            return name.indexOf('.') < 0 || name.indexOf('.share') >= 0;
        },
        emptyText() {
            return this.currentBucket.id ? '该文件夹暂无文件' : '请先选择文件夹';
        }
    },
    methods: {
        loadBucket() {
            return request({
                url: '/bucket/list',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.bucketList = res.data;
                    console.log(this.bucketList);
                }
            });
        },
        filterBucketList(type) {
            switch (type) {
                case 'sys':
                    return _.filter(this.bucketList, function (o) {
                        return o.name.indexOf('.') >= 0;
                    });
                case 'user':
                    return _.filter(this.bucketList, function (o) {
                        return o.name.indexOf('.') < 0;
                    });
                default:
                    return this.bucketList;
            }
        },
        handleChange(value, direction, movedKeys) {
            console.log(value, direction, movedKeys);
        },
        // 左侧菜单展开
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        // 左侧菜单收起
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        selectBucket(data) {
            this.currentBucket = data;
            this.createDocVisible = true;
            this.currentPage = 1;
            this.getBucketFiles();
        },
        // 小屏下拉选择文件夹
        selectBucketById(bucketId) {
            const bucket = this.bucketList.find(o => o.id === bucketId);
            if (bucket) {
                this.selectBucket(bucket);
            }
        },
        getBucketFiles() {
            request({
                url: '/bucket/files',
                method: 'post',
                data: {
                    bucketId: this.currentBucket.id,
                    current: this.currentPage,
                    size: this.pageSize
                }
            }).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.dataTotal = res.total;
                }
            });
        },
        // 切换页码
        handlePageChange(current) {
            this.currentPage = current;
            this.getBucketFiles();
        },
        openCreateBucket() {
            console.log('创建文件夹');
            this.dialogFormMode = 'create';
            this.collectedForm.name = '';
            this.collectedForm.description = '';
            this.collectedForm.isOpen = false;
            this.dialogFormVisible = true;
        },
        openEditBucket() {
            console.log('编辑文件夹');
            this.dialogFormMode = 'edit';
            this.collectedForm.name = this.currentBucket.name;
            this.collectedForm.description = this.currentBucket.description;
            this.collectedForm.isOpen = this.currentBucket.isOpen;
            this.dialogFormVisible = true;
        },
        // 打开上传文件窗口
        openUploadDialog() {
            this.dialogUploadVisible = true; // 先显示组件
            // 等 DOM 渲染完成后，再调用组件方法
            this.$nextTick(() => {
                // 加一层判断，避免极端情况下组件仍未渲染的报错
                if (this.$refs['fileUpload']) {
                    this.$refs['fileUpload'].openPanel();
                }
            });
        },
        saveBucket() {
            if (this.dialogFormMode == 'create') {
                return request({
                    url: '/bucket/create',
                    method: 'post',
                    data: {
                        name: this.collectedForm.name,
                        description: '',
                        token: this.$store.state.user.token,
                        isOpen: this.collectedForm.isOpen
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadBucket();
                    }
                });
            }
            if (this.dialogFormMode == 'edit') {
                return request({
                    url: '/bucket/edit',
                    method: 'post',
                    data: {
                        id: this.currentBucket.id,
                        name: this.collectedForm.name,
                        description: '',
                        token: this.$store.state.user.token,
                        isOpen: this.collectedForm.isOpen
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.currentBucket = res.meta.fileBucket;
                        this.loadBucket();
                    }
                });
            }
        },
        deleteBucket() {
            return request({
                url: '/bucket/delete',
                method: 'post',
                data: {
                    id: this.currentBucket.id,
                    name: this.collectedForm.name,
                    description: this.collectedForm.description,
                    token: this.$store.state.user.token,
                    isOpen: this.collectedForm.isOpen
                }
            }).then(res => {
                if (res.code == 0) {
                    this.currentBucket = {};
                    this.createDocVisible = false;
                    this.loadBucket();
                }
            });
        },
        fileHistory() { },
        fileDownload(data) {
            window.location.href = config().baseServer + 'f/d/' + data.urlPrefix + '/' + data.bucketName + '/' + data.fileName;
        },
        // 复制下载链接到剪贴板
        copyDownloadUrl(data) {
            let url = config().baseServer + 'f/d/' + data.urlPrefix + '/' + data.bucketName + '/' + data.fileName;
            copy(url);
            ElMessage({
                message: `复制成功：${url}`,
                type: 'success',
                duration: 1 * 1000
            });
        },
        fileShare(row) {
            return request({
                url: '/file/share',
                method: 'post',
                data: {
                    cursorId: row.id,
                    fileId: row.fileId
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg || '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                    });
                } else {
                    ElMessage({
                        message: res.msg || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    });
                }
            });
        },
        fileDelete(row) {
            console.log('删除');
            return request({
                url: '/file/delete',
                method: 'post',
                data: {
                    cursorId: row.id,
                    fileId: row.fileId
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg || '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                    });

                    // 删除的是当前页最后一条时，回到上一页，避免停留在空白页
                    if (this.tableData.length === 1 && this.currentPage > 1) {
                        this.currentPage = this.currentPage - 1;
                    }
                    this.getBucketFiles();
                } else {
                    ElMessage({
                        message: res.msg || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    });
                }
            });
        },
        uploadCallback(data) {
            console.log('uploadCallback');
            console.log(data);
            this.getBucketFiles();
        },
        getHidocFileList(current) {
            this.currentPage = current;
            request({
                url: '/file/hidocList',
                method: 'post',
                data: {
                    token: this.$store.state.user.token,
                    current: this.currentPage,
                    size: this.pageSize
                }
            }).then(res => {
                if (res.code == 0) {
                    this.hidocFileList = res.data;
                    this.dataTotal = res.total;
                    document.getElementById('fileContainer').scrollTop = 0;
                }
            });
        }
    }
};
</script>

<style>
/* 整体固定布局：工具栏、左侧菜单、分页固定，仅文件卡片区域滚动 */
.file-manager {
    height: 100%;
}

.file-manager .el-main {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
}

/*
 * 分栏容器用默认的 nowrap 弹性盒：
 * nowrap 下整行高度就等于容器高度，左右两栏被拉伸到满高，
 * 内部的 flex 子项才能拿到有界高度、正确出现滚动条。
 * （不能用 el-row，它是 flex-wrap: wrap，高度会被卡片内容撑开）
 */
.file-manager__body {
    display: flex;
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}

/* 左侧文件夹菜单固定，菜单项过多时自身滚动 */
.file-manager__aside {
    flex: 0 0 12.5%;
    min-width: 0;
    overflow-y: auto;
}

/* 右侧：卡片区域滚动 + 分页固定 */
.file-manager__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
}

.file-manager__grid {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

/* 页面级前缀，避免这条卡片规则泄漏到其它路由 */
.file-manager .el-card {
    margin: 10px;
}

/* 顶部操作栏 */
.file-toolbar {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
    padding: 10px 16px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    border: 1px solid #ebeef5;
    border-radius: 12px;
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}

.file-toolbar__info {
    display: flex;
    align-items: center;
    min-width: 0;
}

.file-toolbar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #79bbff 0%, #337ecc 100%);
    box-shadow: 0 8px 16px -10px rgba(51, 126, 204, 0.9);
}

.file-toolbar__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.file-toolbar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #303133;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.file-toolbar__subtitle {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb2;
}

/* 文件夹下拉选择：仅小屏显示（替代左侧列表） */
.file-toolbar__folder {
    display: none;
}

.file-toolbar__actions {
    display: flex;
    flex: none;
    align-items: center;
}

/* 操作分组之间的分隔线 */
.file-toolbar__split {
    width: 1px;
    height: 18px;
    margin: 0 10px;
    background-color: #e4e7ed;
}

.file-toolbar__actions .toolbar-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.file-toolbar__actions .toolbar-btn > .el-icon {
    margin-right: 6px;
    font-size: 15px;
}

.file-toolbar__actions .toolbar-btn + .toolbar-btn {
    margin-left: 8px;
}

/* 次级操作：描边按钮 */
.file-toolbar__actions .toolbar-btn--ghost {
    color: #606266;
    background-color: #fff;
    border-color: #e4e7ed;
}

.file-toolbar__actions .toolbar-btn--ghost:hover,
.file-toolbar__actions .toolbar-btn--ghost:focus {
    color: #409eff;
    background-color: #f2f8ff;
    border-color: #a0cfff;
    transform: translateY(-1px);
    box-shadow: 0 10px 18px -12px rgba(64, 158, 255, 0.9);
}

.file-toolbar__actions .toolbar-btn--danger:hover,
.file-toolbar__actions .toolbar-btn--danger:focus {
    color: #f56c6c;
    background-color: #fef0f0;
    border-color: #fab6b6;
    box-shadow: 0 10px 18px -12px rgba(245, 108, 108, 0.9);
}

/* 主操作：渐变实心按钮 */
.file-toolbar__actions .toolbar-btn--primary {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #409eff 0%, #1e6fd9 100%);
    box-shadow: 0 10px 20px -12px rgba(30, 111, 217, 1);
}

.file-toolbar__actions .toolbar-btn--primary:hover,
.file-toolbar__actions .toolbar-btn--primary:focus {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #66b1ff 0%, #2b7ee0 100%);
    transform: translateY(-1px);
    box-shadow: 0 14px 24px -12px rgba(30, 111, 217, 1);
}
/* 文件卡片分页：悬浮圆角胶囊（配方见 02 第 10.1 节） */
.file-pager {
    display: flex;
    flex: none;
    align-self: center;
    align-items: center;
    gap: 12px;
    max-width: 100%;
    margin: 4px 0 8px;
    padding: 8px 22px;
    border: 1px solid #e6eaf0;
    border-radius: 999px;
    background-color: #ffffff;
    box-shadow: 0 12px 30px -14px rgba(28, 47, 84, 0.22);
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    /*
     * 窄屏改为「整页自然滚动」：内容区（框架 el-main）本身已是滚动容器，
     * 且里面还放着菜单开关按钮，页面再叠固定高度会出现两个纵向滚动条。
     */
    .file-manager,
    .file-manager .el-main {
        display: block;
        height: auto;
        overflow: visible;
    }
    .file-manager__body {
        display: block;
        margin-top: 12px;
    }
    .file-manager__content {
        display: block;
    }
    .file-manager__grid {
        overflow: visible;
    }

    /* 左侧文件夹列表改为工具条内的下拉选择 */
    .file-manager__aside {
        display: none;
    }
    .file-toolbar {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
    .file-toolbar__folder {
        display: block;
        width: 100%;
    }

    /* 操作按钮换行排列，去掉分组竖线（换行后会显得突兀） */
    .file-toolbar__actions {
        flex-wrap: wrap;
        gap: 8px;
    }
    .file-toolbar__actions .toolbar-btn + .toolbar-btn {
        margin-left: 0;
    }
    .file-toolbar__split {
        display: none;
    }

    /* 分页胶囊悬浮在底部，不必先滚到底才能翻页 */
    .file-pager {
        position: sticky;
        bottom: 10px;
        z-index: 1;
        width: fit-content;
        margin: 4px auto;
    }
}
</style>
